enum CloudProviderEnum {
  AWS = "AWS",
  Azure = "Azure",
  GCP = "GCP",
}

const RegionsByCloudProvider: { [key in CloudProviderEnum]: string[] } = {
  [CloudProviderEnum.AWS]: ["US WEST (OREGON)", "US EAST (OHIO)", "US EAST (N. VIRGINIA)"],
  [CloudProviderEnum.Azure]: ["CENTRAL US (IOWA)", "EAST US (VIRGINIA)", "EAST US 2 (VIRGINIA)", "SOUTH CENTRAL US (TEXAS)", "WEST US 2 (WASHINGTON)"],
  [CloudProviderEnum.GCP]: ["CENTRAL1 (IOWA)", "US EAST4 (N. VIRGINIA)"],
};

export { CloudProviderEnum, RegionsByCloudProvider };
